import React from 'react';

const SVG = ({
  style = {},
  fill = '#006eaf',
  viewBox = '0 0 19.5 24',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g fill={fill}>
      <path fill-rule="evenodd" d="M14.5 0H1v24h19.5V6zM13 18H4v-1.5h9zm-9-3h13.5v-1.5H4zm13.5-3H4v-1.5h13.5zM4 9h13.5V7.5H4z" transform="translate(-1)"/>
    </g>  
  </svg> 
);
export default SVG;
